// Auth
export const AUTH_PASSWORD_MIN_LENGTH = 10
export const AUTH_PASSWORD_RESET_RESEND_COOLDOWN_SECONDS = 60

// Stamps
export const MAX_STAMPS_PER_TRANSACTION = 20
export const STAMP_INACTIVITY_EXPIRY_DAYS = 365

// QR
export const MEMBER_QR_EXPIRY_SECONDS = 600
export const MEMBER_QR_REFRESH_BUFFER_SECONDS = 90

// Device pairing
export const PAIRING_CODE_LENGTH = 6

// Cashier PIN
export const CASHIER_PIN_LENGTH = 4

// Referrals
export const REFERRAL_BONUS_STAMPS = 1

// Rewards
export const REWARD_EXPIRY_DAYS = 365

// Member
export const MEMBER_ID_REGEX = /^CO\d{6}$/i

// Layout
export const SHEET_SAFE_BOTTOM_OFFSET = 24
